export default "__VITE_ASSET__NKl$ePre__"